import { useI18n } from "../../i18n/I18nProvider";
import { cn } from "../../lib/cn";

/** The session's language. `onBand` styles it for the ultramarine header (SP-032). */
export function LanguageSwitch({ onBand = false }: { onBand?: boolean }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <label className="inline-flex items-center gap-2 text-sm">
      <span className="visually-hidden">{t("nav.language")}</span>
      <select
        className={cn(
          "h-8 rounded-md border px-2 text-sm",
          onBand
            ? "border-band-foreground/40 bg-band text-band-foreground"
            : "bg-background text-foreground",
        )}
        value={locale}
        onChange={(event) => {
          setLocale(event.target.value === "fi" ? "fi" : "en");
        }}
      >
        <option value="en">English</option>
        <option value="fi">Suomi</option>
      </select>
    </label>
  );
}
